<template>
    <div>
        <group-card title="Work Basket" icon="shopping_basket" padded>

            <template slot="actions">
              <md-switch
                class="md-primary"
                v-model="showIwlrDeals"
              >
                INS Deals
              </md-switch>
              <div v-if="userHasPermission('view kanban-workbasket')">
                <md-switch
                  class="md-primary"
                  v-model="advance_search_application.isPipelineViewOn"
                >
                  Pipeline View
                </md-switch>
              </div>
              <!-- New app button -->
              <!-- Remove functionality as per SDT-549 -->
              <!-- <md-button
                @click="exportDriveLeads"
                class="md-icon-button md-primary md-simple new-app-button"
                v-if="userHasPermission('export drive-leads')"
              >
                <md-icon
                  id="new-app-icon"
                >file_download</md-icon>
                Export Leads
                <md-tooltip md-direction="top">Export For Drive Leads</md-tooltip>
              </md-button> -->

                <loading-icon-button
                    @click="refreshAndUpdateWorkBasket(true)"
                    tooltip="Refresh"
                    :loading="status == 'loading'"
                >
                    refresh
                </loading-icon-button>

            </template>

            <div>
              <WorkBasketFilters @searchapply="searchapply"/>
              <div v-if="showIwlrDeals">
                <iwl-dashboard />
              </div>
              <div v-else>
                <div v-if="advance_search_application.isPipelineViewOn">
                  <pipeline-dashboard
                    @update="openApplicationEditor"
                    filterable
                  />
                </div>
                <div v-else>
                  <application-list
                    :items="filtered_work_basket_applications"
                    :loading.sync="loading_status"
                    @update="openApplicationEditor"
                    @view="openApplicationSummary"
                    @update-status="openUpdateStatusDialog"
                    @manage-owners="openManageOwnersDialog"
                    @export-csv="exportCSV"
                    @attachments="openApplicationDocuments"
                    @comment="openCommentDialog"
                    @clone="onCloneApplication"
                    canExport
                    :backend-pagination="backendPagination"
                  />
                </div>
              </div>
            </div>
        </group-card>

    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {GroupCard} from "@/components";
import ValidatedInputs from '@/components/ValidatedInput';
import ButtonGroupInput from "@/components/ValidatedInput/ButtonGroupInput.vue";
import ApplicationList from "@/components/ApplicationList";
import PipelineDashboard from "@/pages/PipelineDashboard";
import LoadingIconButton from '@/components/LoadingIconButton';
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import UpdateComponent from "@/components/TransferAndUpdate/UpdateComponent";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import filters from "@/components/utils/filters";
import WorkBasketFilters from "@/components/WorkBasket/WorkBasketFilters.vue";
import IwlDashboard from "@/pages/IwlDashboard";
import OptionsDialog from "@/components/Dialogs/OptionsDialog";

export default {
    components: {
    GroupCard,
    ...ValidatedInputs,
    ButtonGroupInput,
    ApplicationList,
    LoadingIconButton,
    UpdateComponent,
    LoadingIconTextButton,
    ConfirmDialog,
    WorkBasketFilters,
    PipelineDashboard,
    IwlDashboard
},
    data() {
        return {
            backendPagination: true,
            error: null,
            status: 'unloaded',
            applications: [],
            applications_org:[],
            loading_application_id: null,
            stop_progress_handler: null,
            loading_status: false,
            filterApplicationValues : {
                brokers : [],
                stages : [],
                statuses: [],
                lenders : [],
                asset_types : [],
                pod : [],
                introducers: [],
                pods: [],
            },
            appStages: ["New", "Call Centre", "Doc Collection", "Broker", "Settlement", "Compliance"],
            setReferrerAttribs: {
              showSetReferrerDialog: false,
              useAlternativePayroll: false,
              application: {}
            },
            showIwlrDeals: false,
        };
    },
    watch: {
        work_basket() {
            this.getAndUpdateWorkBasket();
        },
        'advance_search_application.isPipelineViewOn'(newVal, oldVal) {
          // When switching *from* Pipeline to List view (i.e., Pipeline is turned OFF),
          // we refresh the work basket to ensure the application list is up-to-date.
          if (oldVal === true && newVal === false) {
            this.refreshAndUpdateWorkBasket();
          }
        }
    },
    computed: {
        ...mapGetters([
            'user',
            'userHasPermission',
            'userHasRole',
            'work_basket',
            'advance_search_application',
            'system_messages'
        ]),
        filtered_work_basket_applications() {
            return this.applications;
        },
        get_filter_value () {
            let  brokers=[], stages = [], statuses = [], lenders = [], asset_types = [], pod = [], introducers = [], pods=[];
            this.applications_org.forEach(application => {

                if (application.owners.Broker && application.owners.Broker.user.name) {
                    let broker = {...application.owners.Broker.user.name};
                    broker.name = filters.name(broker);
                    brokers.push(broker);
                }

                if (application.status) {
                    statuses.push(application.status.status);
                    stages.push(application.status.stage);
                }

                if (application.lender_name) {
                    lenders.push(application.lender_name);
                }

                if (application.asset_type) {
                    asset_types.push(application.asset_type);
                }

                if (application.owners.Referrer && application.owners.Referrer.user.name) {
                    let introducer = {...application.owners.Referrer.user.name};
                    introducer.name = filters.name(introducer);
                    introducers.push(introducer);
                }

                if (application.owners.Broker && application.owners.Broker.user.pod) {
                    pods.push(application.owners.Broker.user.pod);
                }
            })
            return {
                brokers : brokers,
                stages : stages,
                statuses: statuses,
                lenders : lenders,
                asset_types : asset_types,
                introducers: introducers,
                pods : pods,
            };
        },
    },
    methods: {
        ...filters,
        alertTimer() {
            setTimeout(() => {
                this.error = null
            }, 5000)
        },
        searchapply(search) {
            this.refreshAndUpdateWorkBasket();
        },
        async getAndUpdateWorkBasket(resetFilter = false) {

            // load work basket from store (ensure its loaded then get and update status)
            if (resetFilter) {
                await this.$store.dispatch('reset_advance_filter');
            }
            this.status = 'loading';
            let work_basket_status = await this.$store.dispatch('ensure_work_basket');
            this.applications = this.$store.getters.work_basket;
            this.applications_org = [...this.applications];
            this.status = work_basket_status ? 'loaded' : 'error';

        },
        async refreshAndUpdateWorkBasket(resetFilter = false) {

            if (resetFilter) {
                await this.$store.dispatch('reset_advance_filter');
            }

            // load work basket from store forcing it to be fetched
            this.applications_org = [];
            this.status = 'loading';
            let work_basket_status = await this.$store.dispatch('fetch_work_basket');
            this.applications = this.$store.getters.work_basket;
            this.applications_org = [...this.applications];
            this.status = work_basket_status ? 'loaded' : 'error';
        },
        appStatus(statusID) {
            switch (statusID) {
                case 1:
                    return "Submitted"
                    break;
                case 2:
                    return "In Progress";
                    break;
                case 3:
                    return "Settled";
                    break;
                case 4:
                    return "Awaiting Docs";
                    break;
                default:
                    break;
            }
        },
        getSearchResults() {
        },
        clearSearchQuery() {
            this.search.query.zink_id = '';
            this.search.query.email = '';
            this.search.query.phone = '';
            this.search.query.firstname = '';
            this.search.query.lastname = '';
            this.search.status = false;
            this.search.results = [];
        },
        async openApplicationSummary(application) {
            this.$router.push(`/application/${application.id}/summary`);
        },
        async openApplicationEditor(application) {
          this.$router.push(`/application/${application.id}/capture`);
        },
        async openApplicationDocuments(application) {
            await this.$store.dispatch("load_application", application.id);
            this.$router.push(`/application/${application.id}/documents`);
        },
        showAdvanceFilter() {
            this.advance_search_application.show = true
            this.$store.commit('set_advance_search_application',this.advance_search_application );
        },

        openManageOwnersDialog(application) {
            this.$store.commit('set_application_update_owners_dialog', application);
        },

        async openCommentDialog(application) {
            await this.$store.dispatch("open_comment_dialog", application);
        },

        async onCloneApplication(application) {
            const cloneApplication = { ...application };
            const response = await this.$modal.show(OptionsDialog,{
              title: this.system_messages?.clone_application?.title,
              message: this.system_messages?.clone_application?.message,
              confirmText: this.system_messages?.clone_application?.confirmText,
              cancelText: this.system_messages?.clone_application?.cancelText,
              options: {
                includeDocs: { label: "Documents", value: true },
                includeComment: { label: "Comments", value: true }
              }
            });

            if (response) {
              this.$modal.show(WaitingDialog, {
                title: this.system_messages?.clone_application?.title,
                message: this.system_messages?.clone_application?.waitingText,
              });

              await this.$store.dispatch("clone_loan_application", {
                application_id: cloneApplication.id,
                includeDocs: response?.options?.includeDocs ?? false,
                includeComment: response?.options?.includeComment ?? false,
              });

              const application =  this.$store.getters.application;

              this.closeDialog();
              this.openApplicationEditor(application.loan);
            }
        },

        openUpdateStatusDialog(application) {
            this.$store.commit('set_application_update_status_dialog', application);
        },
        async exportCSV() {
          try {
            this.showLoadingDialog('Processing', 'Please wait while the process being completed');
            let app_ids = this.applications.map(app => app.id);
            let response = await axios.post('/api/v1/document/basket/export', {
              application_ids: app_ids
            });
            if(response.data) {
              this.closeDialog();
              let message = 'Your export has been queued and will be processed in order received. Note during peak periods this may mean wait times from 15mins to over an hour.  Repeated requests will extend wait times.';
              if (app_ids.length > 100) {
                message = "Due to it’s size your export has been scheduled and will be processed after 6PM AEST.";
              }
              this.showConfirmDialog('Processing....', message);
            }
          } catch (error) {
            this.closeDialog()
            console.error(error);
            this.showConfirmDialog('Error', 'Error exporting the work basket.');
          }
        },
      showLoadingDialog(title, message) {
        this.$modal.show(WaitingDialog, {
          title: title,
          message: message,
        });
      },
      showConfirmDialog(title, message) {
        this.$modal.show(ConfirmDialog, {
          title: title,
          message: message,
          confirmText: 'Ok',
        });
      },
      closeDialog()
      {
        if (this.$modal.submit) {
          this.$modal.submit();
        }
      },
      async exportDriveLeads() {
        try {
          this.showLoadingDialog("Processing","Please wait while the process is being handled");
          let response = await this.$store.dispatch("export_drive_leads");
          if(response) {
            this.closeDialog();
            this.showConfirmDialog("Success", "Your export was a success but it might take few minutes before you get it in your email.");
          }
        } catch (e) {
          console.error(e);
          this.showConfirmDialog("Error", "Error exporting Drive Leads.");
        }
      },
    },
    filters: {
        ...filters,
    },
    async created() {
      if (this.userHasPermission('manage user_pods')) {
        await this.$store.dispatch('fetch_administration_user_pods', false);
      }

      const currentUserPods = this.$store.state.user.user_pods.map(pod => pod.id) ?? [];
      if (!this.$store.state.administration_pods) {
        if (currentUserPods && currentUserPods.length) {
          this.advance_search_application.pods = currentUserPods;
          this.advance_search_application.active = true;
        }
      };

      await this.$store.commit('set_pagination', {
        ...this.$store.state.pagination,
        backend_pagination: this.backendPagination
      });

      this.refreshAndUpdateWorkBasket();
    },
};
</script>
<style lang="scss">
@import '../assets/scss/theme.scss';
@import '../assets/scss/md-custom/_ausloans-colors.scss';

button.md-button.md-icon-button.md-primary.md-simple.new-app-button {
    width: 150px !important;
    font-size:12px !important;
    color: #ffffff !important;
    background-color: $ausloans-blue !important;
}
#new-app-icon {
    font-size:20px !important;
    color: #ffffff !important;
}
.new-app-button:focus, .new-app-button:active, .new-app-button:hover {
    box-shadow: 0 14px 26px -12px rgba(33, 150, 243, 0.42), 0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(33, 150, 243, 0.2) !important;
    background-color: #128ff2 !important;
}

</style>
